import React from "react";
import {
  StyleSheet,
  View,
  Modal,
  TouchableWithoutFeedback,
} from "react-native";
import Cross from "@assets/svg/CrossIcon";
import Text from "@components/CustomText";
import color from "@constants/color";

function DeliveryPerformanceModal({ summary, showModal, setShowModal }) {
  return (
    <Modal visible={showModal} animationType="slide" transparent>
      <TouchableWithoutFeedback
        onPress={() => {
          setShowModal(false);
        }}
      >
        <View style={styles.modalOverlay} />
      </TouchableWithoutFeedback>
      <View style={styles.modalContent}>
        <View style={styles.modalCross}>
          <TouchableWithoutFeedback onPress={() => setShowModal(false)}>
            <Cross width={16} height={16} />
          </TouchableWithoutFeedback>
        </View>
        <View style={styles.modalInnerContent}>
          <Text variant="title_20">{summary?.extra_info_title}</Text>
          <View style={styles.summaryContainer}>
            {summary?.extra_info.map((item) => (
              <View key={item?.title} style={styles.listItem}>
                <Text variant="caption_2" style={styles.routeName}>
                  {item.title}
                </Text>
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  {item?.rating_txt && (
                    <Text
                      variant="caption_4"
                      style={{
                        marginRight: 8,
                        color: item?.rating_color,
                        lineHeight: 18,
                      }}
                    >{`${item.rating_txt}`}</Text>
                  )}
                  <Text variant="body_text_2">{`${item.value}`}</Text>
                </View>
              </View>
            ))}
          </View>
          <View style={styles.totalContainer}>
            <Text variant="caption_2" style={styles.totalLabel}>
              {summary?.result?.title}
            </Text>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {summary?.result?.rating_txt && (
                <Text
                  variant="subtitle_16"
                  style={{
                    marginRight: 8,
                    color: summary?.result?.rating_color,
                  }}
                >{`${summary?.result?.rating_txt}`}</Text>
              )}
              <Text variant="title_20">{summary?.result?.value}</Text>
            </View>
          </View>
        </View>
      </View>
    </Modal>
  );
}

export default DeliveryPerformanceModal;

const styles = StyleSheet.create({
  modalOverlay: {
    backgroundColor: color.borderColor,
    flex: 1,
  },
  modalContent: {
    backgroundColor: color.white,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    width: "100%",
    position: "absolute",
    bottom: 0,
  },
  modalCross: {
    position: "absolute",
    right: 10,
    top: -35,
    backgroundColor: color.white,
    borderRadius: 50,
    zIndex: 1,
    padding: 6,
  },
  modalInnerContent: {
    padding: 16,
  },
  summaryContainer: {
    backgroundColor: color.white,
    padding: 12,
    borderColor: color.lighterBlack,
    borderWidth: 1,
    marginVertical: 12,
    borderRadius: 16,
  },
  listItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 4,
    paddingVertical: 4,
    borderRadius: 16,
    alignItems: "center",
  },
  routeName: {
    color: color.black06,
  },
  totalContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 8,
    paddingVertical: 6,
    borderRadius: 16,
    alignItems: "center",
  },
  totalLabel: {
    color: color.black06,
  },
});
